import AbstractValidator from './abstractValidator';

/**
 * @class ItemAvailableValidator
 * @extends AbstractValidator
 */
export default class ItemAvailableValidator extends AbstractValidator {
    /**
     * @param {ProblemFactory} problemFactory
     * @param {string} message
     */
    constructor(problemFactory, message) {
        super(problemFactory);
        this.message = message;
    }

    _isItemSupported(item) {
        return item.supportsAvailability;
    }

    _isItemValid(item) {
        return !!item.get('available') || !!item.get('customProduct');
    }

    _createProblems(item) {
        return [this.problemFactory.createWarning('itemDeliverable', this.message, 'truck', [item])];
    }
}
